<template>
  <div class="mx3 p2 mt2 flex pointer action" @click="router.push({name: path})">
    <span class="semi-bold flex items-center">{{title}}</span>
    <i class="icon-angle-right-icon action-arrow flex flex-auto justify-end"></i>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  setup() {
    const router = useRouter();
    return { router }
  },
  props: {
    title: {
      type: String,
      default: 'My title'
    },
    path: {
      type: String,
      default: 'Accueil'
    }
  }
};
</script>

<style scoped>


</style>
